import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const FavCtx = createContext(null);

export function FavoritosProvider({ children }) {
  const { user } = useAuth();
  const [refs, setRefs] = useState(new Set());

  const cargar = useCallback(async () => {
    try {
      const { data } = await api.get("/favoritos/refs");
      setRefs(new Set(data.refs || []));
    } catch { /* sin sesión */ }
  }, []);

  useEffect(() => {
    if (user && user !== false) cargar();
    else setRefs(new Set());
  }, [user, cargar]);

  const isFav = useCallback((refId) => refs.has(refId), [refs]);

  const toggle = useCallback(async (item) => {
    const prev = new Set(refs);
    const activo = refs.has(item.ref_id);
    // optimista
    const next = new Set(refs);
    if (activo) next.delete(item.ref_id); else next.add(item.ref_id);
    setRefs(next);
    try {
      const { data } = await api.post("/favoritos/toggle", item);
      toast.success(data.activo ? "Añadido a favoritos" : "Quitado de favoritos");
    } catch {
      setRefs(prev);
      toast.error("No se pudo actualizar favoritos.");
    }
  }, [refs]);

  return <FavCtx.Provider value={{ isFav, toggle, refresh: cargar }}>{children}</FavCtx.Provider>;
}

export const useFavoritos = () => useContext(FavCtx) || { isFav: () => false, toggle: async () => {}, refresh: () => {} };
